import { Dialog, DialogContent } from '../ui/dialog';

type Props = {
  open: boolean;
  setOpen: (pOpen: boolean) => void;
  url: string
};

const UserLevelReportModal = ({ open, setOpen, url }: Props) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="h-[80%] w-[80%] max-h-[90%] max-w-[90%] md:max-h-[80%] md:max-w-[80%] p-8 bg-white flex flex-col gap-2"
        onInteractOutside={e => e.preventDefault()}
      >
        <div className="w-full h-full">
          <iframe 
            src={url}
            className="h-full w-full"
            title="user-level-dashboard"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UserLevelReportModal;
